import { getServiceUrl } from '../api.config';
import {
  Referential,
  ReferentialNewData,
  ReferentialUpdateData,
} from '../types';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';

export default class BuyingUnitApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('buyingunit'), options);
  }

  public SharingUnitDelete(sharingUnitId: number) {
    const query = `/buyingunit/v2/sharingunits/${sharingUnitId}`;
    return this.delete(query);
  }

  // Referentials
  public CustomReferential(params: any) {
    const query = `/buyingunit/v2/fields/${params.type}/${params.key}`;
    return this.get(query);
  }

  public ListReferentials(params: any) {
    const query = `/buyingunit/v2/referentials`;
    return this.get(query, qs.stringify(params, true));
  }

  public ListAdminReferentials(params: any) {
    const query = `/buyingunit/v2/referentials/admin`;
    return this.get(query, qs.stringify(params, true));
  }

  public CreateReferential(data: any) {
    const query = `/buyingunit/v2/referentials`;
    return this.post(query, data);
  }

  public UpdateReferential(data: any) {
    const query = `/buyingunit/v2/referentials`;
    return this.put(query, data);
  }

  public UpdateReferentialEntity = (
    referentialId: number,
    data: ReferentialUpdateData,
  ) =>
    this.put<Referential>(`/buyingunit/v2/referential/${referentialId}`, {
      data,
    });

  public AddChildrenToReferential = (
    referentialId: number,
    data: ReferentialNewData,
  ) =>
    this.post<Referential>(
      `/buyingunit/v2/referential/${referentialId}/children/add`,
      {
        data,
      },
    );
}
